const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallaxy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 37.5,
    ry: 105,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    transform: "rotate(-45.001 255.998 256.004)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.218 303.782c-64.437-64.437-95.28-138.066-68.89-164.455M303.782 208.218c64.436 64.437 95.28 138.066 68.89 164.455-12.697 12.697-36.33 12.145-64.614.976",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.268 255.451c-45.571-66.81-60.587-130.33-32.367-158.55 15.495-15.495 41.633-17.955 73.115-9.478M210.998 347.194a520.425 520.425 0 0 1-23.816-22.376M325.33 419.257c-28.975-10.633-61.336-29.34-93.546-54.723M382.732 256.549c45.571 66.81 60.587 130.331 32.367 158.55",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.016 87.423c39.417 10.613 87.212 38.371 132.982 79.152",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.636 104.35c-.661-23.414 5.281-42.775 18.61-56.104 36.556-36.556 118.477-17.55 204.953 40.851M80.704 240.376c-18.9-29.822-32.958-58.852-41.498-85.384M176.856 356.352a688.79 688.79 0 0 1-10.719-10.489c-30.23-30.23-56.159-61.744-77.047-92.676M284.782 439.353c-16.673-9.848-33.679-21.27-50.71-34.144M298.308 447.038a456.686 456.686 0 0 1-13.527-7.685M454.31 312.251c32.524 65.403 38.331 122.616 9.444 151.503-24.484 24.484-69.317 24.044-122.239 3.537M366.62 187.82c21.476 23.447 40.347 47.385 56.284 70.983M301.561 125.586c14.926 12.467 29.762 26.012 44.302 40.551M262.466 272.255c6.273 5.418 12.539 10.183 18.592 14.199.495-.448.981-.91 1.459-1.387 15.349-15.349 15.349-40.234 0-55.583s-40.234-15.349-55.583 0c-.477.477-.939.964-1.387 1.459 6.537 9.853 15.059 20.27 25.15 30.361",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.383,
    cy: 355.257,
    r: 13.501,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.934,
    cy: 128.721,
    r: 15,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.467,
    cy: 176.741,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 61,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 181,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 450.958,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 346,
    r: 15.042,
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 10.462C462 32.298 479.702 50 501.538 50H512h-10.462C479.702 50 462 67.702 462 89.538V100 89.538C462 67.702 444.298 50 422.462 50H412h10.462C444.298 50 462 32.298 462 10.462V0v10.462zM50 422.462C50 444.298 67.702 462 89.538 462H100 89.538C67.702 462 50 479.702 50 501.538V512v-10.462C50 479.702 32.298 462 10.462 462H0h10.462C32.298 462 50 444.298 50 422.462V412v10.462z",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallaxy);
export default __webpack_public_path__ + "static/media/gallaxy.c50d69fdd95bbefe95df9980ca3f1182.svg";
export { ForwardRef as ReactComponent };